"use client";
import { FormEvent, FormHTMLAttributes, ReactNode, useCallback } from "react";
import styled, { css, CSSProperties } from "styled-components";
import { screens, shadow } from "../../styles/globalsStyles";
import { defaultTheme } from "../../styles/defaultTheme";

const StyledForm = styled.form<{ $width?: CSSProperties["width"] }>`
  max-height: 100%;
  overflow: auto;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  border: 1px solid ${defaultTheme.tertiaryColor};
  /* justify-content: center; */
  align-items: center;
  width: ${({ $width }) => ($width ? $width : "fit-content")};
  ${shadow}
  ${screens({
    mobile: css`
      padding: 1rem;
    `,
    desktop: css`
      padding: 2rem;
    `
  })}
`;
type FormProps = {
  children: ReactNode;
  width?: string;
  onSubmit?: () => void;
} & FormHTMLAttributes<HTMLFormElement>;
export const Form = (props: FormProps) => {
  const children = props.children;
  const width = props.width;
  const onSubmit = props.onSubmit;
  const handleSubmit = useCallback(
    (e: FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      if (onSubmit) {
        onSubmit();
      }
    },
    [onSubmit]
  );

  return (
    <StyledForm $width={width} onSubmit={handleSubmit} {...props}>
      <>{children}</>
    </StyledForm>
  );
};
